import katex, { KatexOptions } from 'katex';

const KATEX_OPTS: KatexOptions = {
	throwOnError: false,
	strict: false,
	errorColor: '#f59e0b',
	macros: { '\\boxed': '#1' },
};

// Key omits KATEX_OPTS because it's a module-scope constant; widen the key
// if that changes. Failures cached too - malformed math shouldn't retry
// katex.renderToString every frame.
type KatexCacheValue = { ok: true; html: string } | { ok: false };
const katexCache = new Map<string, KatexCacheValue>();
const KATEX_CACHE_MAX = 500;

export function renderKatexCached(
	mathText: string,
	displayMode: boolean,
): KatexCacheValue {
	const key = `${displayMode ? 'd' : 'i'}:${mathText}`;
	const cached = katexCache.get(key);
	if (cached) {
		// LRU touch: re-insert to move to insertion-order tail.
		katexCache.delete(key);
		katexCache.set(key, cached);
		return cached;
	}
	let result: KatexCacheValue;
	try {
		const html = katex.renderToString(mathText, { ...KATEX_OPTS, displayMode });
		result = { ok: true, html };
	} catch {
		result = { ok: false };
	}
	katexCache.set(key, result);
	if (katexCache.size > KATEX_CACHE_MAX) {
		const oldestKey = katexCache.keys().next().value;
		if (oldestKey !== undefined) katexCache.delete(oldestKey);
	}
	return result;
}
